module.exports = {"542429100":"雅安镇","542429101":"拉西镇","542429102":"杂色镇","542429200":"江绵乡","542429201":"岗切乡","542429202":"巴青乡","542429203":"阿秀乡","542429204":"玛如乡","542429205":"本塔乡","542429206":"贡日乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542429.json
// module id = 2559
// module chunks = 0